import { useQuery } from '@tanstack/react-query'
import { xdrSweepQuery, type XdrSource, type XdrSweepKind } from '../api/securitee'
import { Spinner } from '../ui/Spinner'

const WHAT: Record<XdrSweepKind, string> = { sha256: 'this file', ip: 'this IP', path: 'this path' }

/**
 * "Unde mai e?" (docs XDR 03, decizia 9): pe ce aparate ale firmei incidentului
 * a aparut un hash, un IP sau o cale, in cele 30 de zile dinaintea
 * incidentului. Aparatul incidentului e marcat. Numai citire.
 */
export function XdrSweep({ from, kind, value, onClose }: { from: XdrSource; kind: XdrSweepKind; value: string; onClose: () => void }) {
  const query = useQuery(xdrSweepQuery(from, kind, value))
  const label = kind === 'sha256' ? `sha256 ${value.slice(0, 16)}…` : value

  return (
    <div className="xdr-sweep" role="region" aria-label={`Where else is ${label}`}>
      <div className="xdr-sweep-head">
        <strong>Where else is {WHAT[kind]}?</strong> <code className="xdr-value">{label}</code>
        <button type="button" className="btn btn-link btn-xs" onClick={onClose}>
          Close
        </button>
      </div>
      {query.isPending ? (
        <Spinner />
      ) : query.isError ? (
        <p className="color-red">{query.error instanceof Error ? query.error.message : 'The search failed.'}</p>
      ) : query.data.devices.every((d) => d.current) ? (
        <p className="font-grey-cascade">Only on this device since {query.data.since.slice(0, 10)}.</p>
      ) : (
        <>
          <p className="font-grey-cascade">
            Seen on {query.data.devices.length}
            {query.data.truncated ? '+' : ''} devices since {query.data.since.slice(0, 10)}.
          </p>
          <ul className="list-unstyled xdr-sweep-list">
            {query.data.devices.map((d) => (
              <li key={d.device_id} className="xdr-sweep-device">
                <strong>{d.device_name}</strong>
                {d.current && <span className="label label-default">this device</span>}{' '}
                <span className="font-grey-cascade">
                  {d.first_seen.slice(0, 16)} → {d.last_seen.slice(0, 16)} UTC · {d.hits === 1 ? 'once' : `${d.hits} times`}
                </span>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  )
}
